import { Campaign, CampaignType } from '../api/interfaces'
import { AudienceTargeting, LocationTargeting, LocationTargetingType, LocationTypeToLocationTargetingType } from '../api/interfaces/CampaignTargeting'
import { LocationType } from '../components/targeters/GeoSelectionTargeter'
import { DEFAULT_AUDIENCE_TARGETING, DEFAULT_LOCATION_TARGETING } from './TargetingFormDefaults'

export const GetLocationTargeting: (campaign?: Campaign) => LocationTargeting = campaign => {
  const baseTargeting: LocationTargeting = DEFAULT_LOCATION_TARGETING

  if (!campaign) {
    return baseTargeting
  }

  if (campaign.type === CampaignType.Internet) {
    if (!!campaign.advancedTargeting) {
      baseTargeting.targetingType = LocationTypeToLocationTargetingType(campaign.advancedTargeting.locationType as LocationType)
      if (baseTargeting.targetingType === LocationTargetingType.Address) {
        baseTargeting.geoFences = campaign.advancedTargeting.geoFences.map(g => ({
          placeId: g.placeId,
          radiusUnits: g.radiusUnits,
          formattedAddress: g.name,
          radius: g.radius,
          geocodedAddress: g.name,
          lat: g.lat,
          lng: g.lng
        }))
      } else if (baseTargeting.targetingType === LocationTargetingType.Map) {
        baseTargeting.geoCircles = campaign.advancedTargeting.geoCircles ?? []
        baseTargeting.geoRectangles = campaign.advancedTargeting.geoRectangles ?? []
        baseTargeting.geoPolygons = campaign.advancedTargeting.geoPolygons ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Region) {
        baseTargeting.regions = campaign.advancedTargeting.locations?.regions ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.DMA) {
        baseTargeting.dmas = campaign.advancedTargeting.locations?.dmas ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.City) {
        baseTargeting.cities = campaign.advancedTargeting.locations?.cities ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Zip) {
        baseTargeting.zips = campaign.advancedTargeting.locations?.postalCodes ?? []
      }
      baseTargeting.uploadedAudienceUrl = campaign.advancedTargeting.locations?.uploadedAudienceUrl
    } else {
      baseTargeting.targetingType = LocationTargetingType.Region
      if (campaign.standardTargeting) {
        baseTargeting.regions = campaign.standardTargeting.locations?.regions ?? []
        baseTargeting.dmas = campaign.standardTargeting.locations?.dmas ?? []
        baseTargeting.cities = campaign.standardTargeting.locations?.cities ?? []
        baseTargeting.zips = campaign.standardTargeting.locations?.postalCodes ?? []
        baseTargeting.uploadedAudienceUrl = campaign.standardTargeting.locations?.uploadedAudienceUrl
      }
    }
  } else if (campaign.type === CampaignType.TV) {
    if (campaign.tvTargeting) {
      baseTargeting.targetingType = LocationTypeToLocationTargetingType(campaign.tvTargeting.locationType as LocationType)
      if (baseTargeting.targetingType === LocationTargetingType.Address) {
      } else if (baseTargeting.targetingType === LocationTargetingType.City) {
        baseTargeting.cities = campaign.tvTargeting.locations?.cities ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.DMA) {
        baseTargeting.dmas = campaign.tvTargeting.locations?.dmas ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Region) {
        baseTargeting.regions = campaign.tvTargeting.locations?.regions ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Zip) {
        baseTargeting.zips = campaign.tvTargeting.locations?.postalCodes ?? []
      }
      baseTargeting.uploadedAudienceUrl = campaign.tvTargeting.locations?.uploadedAudienceUrl
    }
  } else if (campaign.type === CampaignType.Billboard) {
    if (campaign.billboardTargeting) {
      baseTargeting.targetingType = LocationTypeToLocationTargetingType(campaign.billboardTargeting.locationType as LocationType)
      if (baseTargeting.targetingType === LocationTargetingType.Address) {
      } else if (baseTargeting.targetingType === LocationTargetingType.City) {
        baseTargeting.cities = campaign.billboardTargeting.locations?.cities ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.DMA) {
        baseTargeting.dmas = campaign.billboardTargeting.locations?.dmas ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Region) {
        baseTargeting.regions = campaign.billboardTargeting.locations?.regions ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Zip) {
        baseTargeting.zips = campaign.billboardTargeting.locations?.postalCodes ?? []
      }
      baseTargeting.uploadedAudienceUrl = campaign.billboardTargeting.locations?.uploadedAudienceUrl
    }
  } else if (campaign.type === CampaignType.Audio) {
    if (campaign.audioTargeting) {
      baseTargeting.targetingType = LocationTypeToLocationTargetingType(campaign.audioTargeting.locationType as LocationType)
      if (baseTargeting.targetingType === LocationTargetingType.Address) {
      } else if (baseTargeting.targetingType === LocationTargetingType.City) {
        baseTargeting.cities = campaign.audioTargeting.locations?.cities ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.DMA) {
        baseTargeting.dmas = campaign.audioTargeting.locations?.dmas ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Region) {
        baseTargeting.regions = campaign.audioTargeting.locations?.regions ?? []
      } else if (baseTargeting.targetingType === LocationTargetingType.Zip) {
        baseTargeting.zips = campaign.audioTargeting.locations?.postalCodes ?? []
      }
      baseTargeting.uploadedAudienceUrl = campaign.audioTargeting.locations?.uploadedAudienceUrl
    }
  }

  return baseTargeting
}

export const GetAudienceTargeting: (campaign?: Campaign) => AudienceTargeting = (campaign?: Campaign) => {
  const baseTargeting: AudienceTargeting = DEFAULT_AUDIENCE_TARGETING
  if (!campaign) {
    return baseTargeting
  }

  if (campaign.type === CampaignType.Internet && campaign.advancedTargeting) {
    baseTargeting.demographics = {
      ageRanges: campaign.advancedTargeting.ageRanges,
      genders: campaign.advancedTargeting.genders,
      householdIncomes: campaign.advancedTargeting.householdIncomes
    }
    baseTargeting.segments = campaign.advancedTargeting.segments ?? []
    baseTargeting.uploadedAudienceUrl = campaign.advancedTargeting.uploadedAudienceUrl ?? undefined
    baseTargeting.retargeting = {
      retargetCampaignIds: campaign.advancedTargeting.retargetingCampaignIds ?? [],
      retargetWebsiteUrls: campaign.advancedTargeting.urlParts ?? [],
      entireSite: campaign.advancedTargeting.retargetingType === 'All',
      specificPages: campaign.advancedTargeting.retargetingType === 'Specific'
    }
  } else if (campaign.type === CampaignType.TV && campaign.tvTargeting) {
    baseTargeting.demographics = {
      ageRanges: campaign.tvTargeting.ageRanges,
      genders: campaign.tvTargeting.genders,
      householdIncomes: campaign.tvTargeting.householdIncomes
    }
    baseTargeting.segments = campaign.tvTargeting.segments ?? []
    baseTargeting.uploadedAudienceUrl = campaign.tvTargeting.uploadedAudienceUrl ?? undefined
    baseTargeting.retargeting = {
      retargetCampaignIds: [],
      retargetWebsiteUrls: [],
      entireSite: false,
      specificPages: false
    }
  } else if (campaign.type === CampaignType.Audio && campaign.audioTargeting) {
    baseTargeting.demographics = {
      ageRanges: campaign.audioTargeting.ageRanges,
      genders: campaign.audioTargeting.genders,
      householdIncomes: campaign.audioTargeting.householdIncomes
    }
    baseTargeting.segments = campaign.audioTargeting.segments ?? []
    baseTargeting.uploadedAudienceUrl = campaign.audioTargeting.uploadedAudienceUrl ?? undefined
    baseTargeting.retargeting = {
      retargetCampaignIds: [],
      retargetWebsiteUrls: [],
      entireSite: false,
      specificPages: false
    }
  }

  return baseTargeting
}
